import React from 'react';

import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';

import type { BreadcrumbsRouterProps } from '@packages/fenrir/components';
import { BreadcrumbsRouter } from '@packages/fenrir/components';

// TODO: AGENT-5559 Implement Dynamic Breadcrumb For Group Name
const AgentGroupPageBreadcrumbs = () => {
  const { t } = useTranslation('telemetryAgents');
  const crumbs: BreadcrumbsRouterProps['crumbs'] = [
    {
      label: t('agentSettings.breadcrumbs.agents'),
      to: generatePath('/telemetry/agents'),
    },
    {
      label: t('agentSettings.breadcrumbs.agentSettings'),
      to: generatePath('/telemetry/agents/settings/configuration'),
    },
    {
      label: t('agentSettings.breadcrumbs.default'),
      to: generatePath('/telemetry/agents/settings'),
    },
  ];
  return <BreadcrumbsRouter crumbs={crumbs} />;
};

export default AgentGroupPageBreadcrumbs;
